var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EnderecoCobranca.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-8b72791c!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EnderecoCobranca.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/pessoal/components/minha-conta/editar-meus-dados/EnderecoCobranca.vue
// module id = 510
// module chunks = 2